"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceLabel = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ChoiceNumber = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n  margin-right: 8px;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n  margin-right: 8px;\n  white-space: nowrap;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var Label = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var ChoiceLabel = function (_a) {
    var label = _a.label, choiceNumber = _a.choiceNumber, color = _a.color;
    if (!choiceNumber) {
        return react_1.default.createElement(Label, { color: color }, label);
    }
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(ChoiceNumber, { color: color },
            choiceNumber,
            "."),
        react_1.default.createElement(Label, { color: color }, label)));
};
exports.ChoiceLabel = ChoiceLabel;
var templateObject_1, templateObject_2, templateObject_3;
